import api from '../config/axiosConfig';

export const DashboardService = {
    getInfo: async (token, fechaInicio = '', fechaFin = '', estado='',filtroSupervisor='') => {
        try {
            const response = await api.get('/dashboard/info', {
                headers: { Authorization: `Bearer ${token}` },
                params: {
                    fechaInicio,
                    fechaFin,
                    estado,
                    filtroSupervisor
                }
            });

            return response.data.data || [];
        } catch (error) {
            console.error('Error en DashboardService.getInfo:', error);
            throw error;
        }
    },
};
